<app-header></app-header>
<div id="print-section" >
  <div class="row success_main" >
    <div class="col-12">
      <div class="d-flex align-items-center justify-content-between">
        <div class="flex-grow-1">
          <p *ngIf="status == 'Success'" class="mb-2">
            <i class="fa fa-check"></i> Advance Payment
            <span class="smalltxt ms-2">Your advance payment has been processed successfully.</span>
          </p>
          <p *ngIf="status == 'Failure'" class="mb-2">
            <i class="fa fa-exclamation paymentFailure"></i> Advance Payment
            <span class="smalltxt ms-2">Sorry, there was an issue processing your advance payment.</span>
          </p>
        </div>
        <span class="success_print">
          <a (click)="print()" class="btn btn-outline-secondary">
            <i class="fa fa-print print_icon"></i>
          </a>
        </span>
      </div>
    </div>
  </div>

  <div class="container below_header mt-4">
    <div class="row">
      <div class="col-12">
        <div>
          <span class="order_id transIDWordBreak" *ngIf="transactionStatus.transId">
            Transaction ID : {{transactionStatus.transId}}
          </span>
        </div>
        <div class="detail_list mt-3">
          <p>
            <b>Station(s) :</b> {{transactionStatus.station}}
          </p>
          <p>
            <b>Account Executive :</b> {{transactionStatus.accountExecutive}}
          </p>
        </div>

        <div class="payment_detail_main mt-4">
          <i class="fa fa-credit-card payment_detail_icon"></i>
          <span class="payment_detailtxt ms-2">Payment Details</span>
          <div class="blw_paymentdetail mt-2">
            <p class="full_paymenttxt" *ngIf="transactionStatus.paymentMode === 'ACH'">Total Net Cash Discount Price</p>
            <p class="full_paymenttxt" *ngIf="transactionStatus.paymentMode === 'CC'">Total Net Regular Price</p>
            <p class="full_payment">{{transactionStatus.transAmount | currency:'USD'}}</p>
          </div>
        </div>

        <div *ngIf="status == 'Success'" id="goToHome" class="mt-4">
          <button type="button" (click)="home($event)" class="btn btn-success">
            <i class="fa fa-home home_icon"></i> Go Home
          </button>
        </div>
        <div *ngIf="status == 'Failure'" id="goToHome" class="mt-4">
          <button type="button" (click)="home($event)" class="btn btn-danger">
            <i class="fa fa-home home_icon"></i> Go Home
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
